<template>
    <div>

        <rkm-table
            :fields="fields"
            :items="items"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(codigo)="row">
                <div v-if="row.item.codigo">
                   {{ row.item.codigo | formatProcedimento }}
                </div>
            </template>

            <template v-slot:cell(actions)="{ index }">

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
// Filters.
import formats from '@/filters/formats'

// Mixins.
import { repository } from '@/mixins'

export default {
    computed: {
        fields() {

            return [
                {
                    key: "codigo",
                    label: "Código",
                    class: "col-min",
                },
                {
                    key: "nome",
                    label: "Procedimento",
                },
                {
                    key: "actions",
                    label: "Ações",
                    class: "col-min",
                },
            ]
        },
        items() {

            var items = []
            this.data.model.procedimentos.forEach(element => {
                if(element['padrao'] == true) {
                    items.push(element)
                }
            });

            return items
            
        },
        validations() {

            return {
                procedimento: {},
            }
        },
    },
    methods: {
        destroy(index) {

            const destroy = async () => this.data.model.procedimentos.splice(index, 1)

            this.showDeleteConfirmation('Deseja realmente excluir o procedimento?', destroy)
        },
    },
    filters: {
        ...formats,
    },
    mixins: [repository],
    props: {
        data: { type: Object, required: true },
    }
}
</script>
